import { render, staticRenderFns } from "./list.vue?vue&type=template&id=117c07f2&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style1 from "./list.vue?vue&type=style&index=1&id=117c07f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117c07f2",
  null
  
)

export default component.exports